module.exports = __webpack_public_path__ + "static/media/sezioni.e79fa411.png";